import PageMeta from 'components/PageMeta';
import WordpressContent from 'components/Content/WordpressContent';
import { GetServerSidePropsContext } from 'next';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { GetCmsBlockDocument, GetCmsBlockQuery } from 'generated/graphql';
import { parseContextLocale } from 'utils/parseContextLocale';
import { query } from 'graphql/client';
import { FindConsultant } from '../../components/Consultant/Find/FindConsultant';
import Layout from '../../components/Layout/Layout';
import { getCommonServerSideProps } from '../../server/getCommonServerSideProps';

type Props = {
    cmsBlockContent: string | null;
};

export default function Page({ cmsBlockContent }: Props) {
    const { t } = useServerTranslation();

    return (
        <Layout
            containerProps={{
                sx: {
                    maxWidth: '760px',
                    minHeight: 500,
                    '&': {
                        h1: { marginBottom: '24px' },
                        form: { marginBottom: '40px' },
                        '.description': { marginBottom: '40px' },
                    },
                },
            }}
        >
            <PageMeta
                title={t('seo.title.findconsultant')}
                description={t('seo.description.findconsultant')}
            />
            {cmsBlockContent && <WordpressContent content={cmsBlockContent} />}
            <FindConsultant hideDefaultHeader={Boolean(cmsBlockContent)} />
        </Layout>
    );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    const { market } = await parseContextLocale(context);

    let cmsBlockContent: string | null = null;
    try {
        const { data } = await query<GetCmsBlockQuery>(market, {
            query: GetCmsBlockDocument,
            variables: { title: `find-consultant-${market}` },
        });
        cmsBlockContent = data.cmsBlock?.content ?? null;
    } catch {
        cmsBlockContent = null;
    }

    return getCommonServerSideProps({
        context,
        additionalProps: { cmsBlockContent },
    });
}
